import Vue from 'vue'
import VGroupShop  from './groupShop'

export default VGroupShop


// WEBPACK FOOTER //
// ./src/components/index/mobile/groupShop/index.js